import React from "react";
import Modal from "react-bootstrap/Modal";
import { Button } from "shards-react";
import { EntypoCheck, EntypoClock } from "react-entypo-icons";
import { strings } from "../localization";
import { withRouter } from "react-router-dom";
import { ROUTE_PREFIX } from "../config";
import "./OrderCompleteDialog.css";

function OrderCompleteDialog({
  showModal,
  setShowModal,
  orderData = {},
  history,
  match
}) {
  const {
    orderId = "",
    restaurantName = "",
    completionTime = "",
    totalAmount = "",
    orderItems = []
  } = orderData;

  const handleViewOrder = () => {
    const restaurantName = (match && match.params && match.params.restaurantName) || 'restaurant';
    const currentOrdersPath = `/${ROUTE_PREFIX}${restaurantName}/current-orders`;
    history.push(currentOrdersPath);
    setShowModal(false);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <Modal
      show={showModal}
      onHide={handleClose}
      size="md"
      aria-labelledby="order-complete-modal-title"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="order-complete-header">
        <div className="d-flex align-items-center w-100">
          <div className="success-icon-container">
            <EntypoCheck className="success-icon" />
          </div>
          <div className="ms-3 flex-grow-1">
            <h4 className="mb-0 order-complete-title">
              {strings.order_complete_title}
            </h4>
            <p className="mb-0 order-complete-subtitle">
              {strings.order_complete_subtitle}
            </p>
            <div className="order-info-inline">
              <span className="order-number-inline">{orderId}</span>
              <span className="order-datetime-inline">{completionTime}</span>
            </div>
          </div>
        </div>
        <button
          type="button"
          className="btn-close order-close-btn"
          onClick={handleClose}
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </Modal.Header>

      <Modal.Body className="order-complete-body">
        <div className="order-info-section">

          {orderItems && orderItems.length > 0 && (
            <div className="order-items-section">
              <h6 className="items-title">
                {strings.order_items}:
              </h6>
              <div className="items-list">
                {orderItems.slice(0, 3).map((item, index) => (
                  <div key={index} className="item-row">
                    <span className="item-name">{item.name}</span>
                    <span className="item-quantity">x{item.quantity}</span>
                  </div>
                ))}
                {orderItems.length > 3 ? (
                  <div className="more-items-with-button">
                    <span className="more-items-text">+{orderItems.length - 3} items</span>
                    <Button
                      theme="primary"
                      size="sm"
                      className="view-order-inline-btn"
                      onClick={handleViewOrder}
                    >
                      View Order
                    </Button>
                  </div>
                ) : (
                  <div className="view-order-only">
                    <Button
                      theme="primary"
                      size="sm"
                      className="view-order-inline-btn"
                      onClick={handleViewOrder}
                    >
                      View Order
                    </Button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default withRouter(OrderCompleteDialog);
